(function () {
  'use strict';
  angular.module('vcexam')
    .component('gdtprofilconfig', {
      restrict: 'E',
      bindings: {},
      template: `
        <div class="panel panel-info">
        <div class="panel-heading">
          <h3>GDT Profil</h3>
        </div>
        <div class="panel-body"></div>
          <div class="modalspacer">
            <label>Name des in der Software eingrichteten Profils</label>
            <listeditor list="vm.gdtprofil.gdtprofil" parentsave="vm.childsavepat(list)"></listeditor>
          </div>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Config', 'Rlog', 'vertxEventBusService',
        function ($log, Config, Rlog, vertxEventBusService) {
          let vm = this;
          vm.childsavepat = childsavepat;

          vm.$onInit = function () {

            Config.$find('gdtprofil').$then(function (gdtprofil) {
              vm.gdtprofil = gdtprofil;
              // intialize if still empty
              if (angular.isUndefined(vm.gdtprofil.gdtprofil)) {
                vm.gdtprofil._id = 'gdtprofil';
                vm.gdtprofil.gdtprofil = [];
              }
            });
          };




          function childsavepat(list) {
            vm.gdtprofil.gdtprofil = list;
            savepat();
          }
          

          function savepat() {
            if (vm.gdtprofil.$hasPendingActions()) {
              vm.gdtprofil.$cancel();
            }
            vm.gdtprofil.$save();
          }


          vertxEventBusService.on('config.update', function (message) {
            // $log.debug('debug: config update received: ', message);
            let messages = message.split(':');

            if (messages[0] === 'gdtprofil') {
              vm.gdtprofil.$refresh().$then(function () {
                $log.debug('debug: config refresh gdtprofil');
              }, function (error) {
                $log.debug('debug: config refresh gdtprofil failed: ', error);
              });
            }
          });


        }] // controller
    }); // component

// klammerfriedhof
}());
